import { format } from "date-fns";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";

import {
  Box,
  Chip,
  Table,
  Paper,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Typography,
  TableContainer,
} from "@mui/material";

import Title from "../../../common/Title";
import ApiLogHistory from "../../../common/ApiLogHistory";

import useAxios from "../../../../hooks/useAxios";
import { __getUsageLog } from "../../../../api/sim";
import { getChipColor } from "../../../../constants/value";

const display = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

const withUnit = (value, unit) =>
  value === null || value === undefined ? "-" : `${value}${unit ? ` ${unit}` : ""}`;

const TmobilejUsageHistory = () => {
  const [usageHistory, setUsageHistory] = useState({});
  const { usage_id } = useParams();

  const [response, call, loading] = useAxios({
    ...__getUsageLog(usage_id),
  });

  useEffect(() => {
    if (response && response.status) {
      setUsageHistory(response.data);
    }
  }, [response]);

  useEffect(() => {
    call();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usage_id]);

  const data = usageHistory.data;

  const rows = data
    ? [
        ["MSISDN", data.msisdn],
        [
          "Batch ID",
          <Link underline="none" to={`/tmobilej/usage/batch/${data.batch_id}`}>
            {data.batch_id}
          </Link>,
        ],
        [
          "Status",
          <Chip label={data.status} size="small" color={getChipColor(data.status)} />,
        ],
        ["Used", display(data.used)],
        ["Remaining", display(data.remaining)],
        ["Line Status", display(data.usage_status)],
        ["Current Behavior", display(data.current_behavior)],
        ["Limit", withUnit(data.limit_value, data.value_unit)],
        ["Notify At", withUnit(data.notify_value, data.value_unit)],
        ["Throttle At", withUnit(data.throttle_value, data.value_unit)],
        ["Throttle Speed", display(data.throttle_speed)],
        [
          "Auto Renew",
          data.auto_renew === null || data.auto_renew === undefined
            ? "-"
            : data.auto_renew
            ? "Yes"
            : "No",
        ],
        [
          "Period",
          data.period_value === null || data.period_value === undefined
            ? "-"
            : `${data.period_value}${data.period_type || ""}`,
        ],
        ["Renewal Day", display(data.renewal_day)],
        ["Settings Error", display(data.settings_error)],
        ["Info Error", display(data.info_error)],
        [
          "Last Updated",
          data.last_updated
            ? format(new Date(data.last_updated), "MMMM d, y hh:mm a")
            : "-",
        ],
      ]
    : [];

  return loading ? (
    <Title content="Please wait..." variant="subtitle2" gutterBottom />
  ) : (
    <>
      <Box mb={2} pt={2}>
        <Typography variant="h5" align="left">
          Usage Log
        </Typography>
      </Box>

      {response && data ? (
        <>
          <Box
            sx={{ width: "100%", mb: 5 }}
            display="flex"
            alignItems="center"
            flexDirection="column"
          >
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} size="small">
                <TableHead>
                  <TableRow>
                    <TableCell align="left">Field</TableCell>
                    <TableCell align="left">Value</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map(([label, value]) => (
                    <TableRow key={label}>
                      <TableCell align="left" sx={{ fontWeight: 500, width: 200 }}>
                        {label}
                      </TableCell>
                      <TableCell align="left" sx={{ whiteSpace: "pre-wrap" }}>
                        {value}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <ApiLogHistory data={usageHistory.history.data} />
        </>
      ) : (
        <Box mb={2} pt={2}>
          <Typography variant="h5" align="left">
            No Data
          </Typography>
        </Box>
      )}
    </>
  );
};

export default TmobilejUsageHistory;
